import { workforceOptimizationEntryPoint } from '@jira/spa-apps__servicedesk-workforce-optimization/src/workforceOptimizationEntryPoint.entrypoint.tsx';
import { workforceOptimizationRoute } from '@jira/router-routes__jsm-workforce-optimization-routes/src/workforceOptimizationRoute.tsx';
import {
	connectTeamsGlobalGroupsResource,
	routingSetupStatusResource,
	routingOnboardingFinishedResource,
} from '@jira/router-resources__service-desk-routing/src/routingSetupStatusResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const isWorkforceAemEnabled = (): boolean =>
	fg('jsm_workforce_use_aem') ? isFeatureEnabled('jira-service-management', 'jsm-workforce') : true;

const getConnectTeamsGlobalGroupsResources = () =>
	expVal('global_group_search_wfo', 'isEnabled', false) ? [connectTeamsGlobalGroupsResource] : [];

const entryPoint = createPageEntryPoint({ main: workforceOptimizationEntryPoint });

export const workforceOptimizationRouteEntry: Route = createEntry(
	workforceOptimizationRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		layout: serviceProjectLayout,
		ufoName: 'jsm-workforce-optimization',

		navigation: {
			menuId: 'PROJECTS',
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			routingSetupStatusResource,
			routingOnboardingFinishedResource,
			...getConnectTeamsGlobalGroupsResources(),
		],

		entryPoint: () => {
			if (!isWorkforceAemEnabled() || !fg('jsm_workforce_optimization_main')) {
				return undefined;
			}
			return entryPoint;
		},

		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
